export function arraysEqual<T>(a: T[], b: T[]): boolean {
    if (a.length !== b.length) return false
    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false
    }
    return true
}

export function uniqueNumberIds(ids: number[]): number[] {
    return [...new Set(ids)]
}

export function isFullSelection(selected: number[], available: number[]): boolean {
    const uniqueAvailable = uniqueNumberIds(available)
    const uniqueSelected = uniqueNumberIds(selected)
    if (uniqueSelected.length !== uniqueAvailable.length || uniqueAvailable.length === 0) {
        return false
    }
    const availableSet = new Set(uniqueAvailable)
    return uniqueSelected.every((id) => availableSet.has(id))
}

export function reconcileSelectedIds(prev: number[], nextAvailable: number[]): number[] {
    const uniqueAvailable = uniqueNumberIds(nextAvailable)
    const uniquePrev = uniqueNumberIds(prev)
    const availableSet = new Set(uniqueAvailable)
    const filtered = uniquePrev.filter((id) => availableSet.has(id))
    const next = filtered.length > 0 ? filtered : uniqueAvailable
    return arraysEqual(uniquePrev, next) && prev.length === uniquePrev.length ? prev : next
}
